import e from "../locales/en/common.json.mjs";
import { createI18nInstance as t } from "@systemeio/util";
//#region src/i18n/instance.ts
var { i18n: n } = t({
	compatibilityJSON: "v3",
	resources: { en: { common: e } }
});
//#endregion
export { n as i18n };
